// Application-level feature flags.
//
// These are lightweight, config-driven booleans that let us ship UI that is
// intentionally hidden until a dependency (e.g., a mobile release) is live.
// Toggle them via environment variables without touching component code.

/**
 * Parse an environment string into a boolean. Any value that isn't the exact
 * string "true" (case-insensitive) resolves to false. Undefined/empty => false.
 */
const envBool = (value, defaultValue = false) => {
  if (value === undefined || value === null || value === '') return defaultValue;
  return String(value).toLowerCase() === 'true';
};

/**
 * ENABLE_MOBILE_APP_PROMO
 *
 * Controls the Sub (substitute teacher) "Get real-time shift alerts" mobile app
 * download promo toast on the /toc dashboard. Defaults to FALSE so the promo
 * stays hidden until the native mobile app is published. Flip the env var to
 * "true" to enable it instantly — no code changes required.
 */
export const ENABLE_MOBILE_APP_PROMO = envBool(
  process.env.REACT_APP_ENABLE_MOBILE_APP_PROMO,
  false
);
